import React from "react";
import  ReactDOM  from "react-dom/client";
import image from "./images/equi.jpg";
import eye from "./images/icon-view.svg"

export default function Header() {
    return(
        <header>
            <img src={image} alt = "" className="header-image" />
            <div className="eye"
            >
                 <img src={eye} alt = ""  />
            </div>
        </header>
    )
}